import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';

@Injectable()
export class UtilityService {
  constructor(private _confirmationService: ConfirmationService,
    private _translateService: TranslateService) {

  }
  public randomNumberGenerator(lowerRange: number, upperRange: number) {
    return (Math.random() * upperRange + lowerRange);
  }

  public sleep(milliseconds: number) {
    const start = new Date().getTime();
    for (let i = 0; i < 1e7; i++) {
      if ((new Date().getTime() - start) > milliseconds) {
        break;
      }
    }
  }

  static getValue(target: any, key: any) {
    const keys = key.split('.');
    key = '';
    do {
      key += keys.shift();
      if (this.isDefined(target) && this.isDefined(target[key]) && (typeof target[key] === 'object' || !keys.length)) {
        target = target[key];
        key = '';
      } else if (!keys.length) {
        target = undefined;
      } else {
        key += '.';
      }
    } while (keys.length);
    return target;
  }

  static isDefined = function (value: any) {
    return typeof value !== 'undefined' && value !== null;
  };

  public showError(error: string) {
    this._confirmationService.confirm({
      message: error,
      rejectVisible: false,
      icon: 'pi pi-info-circle',
      acceptLabel: this._translateService.instant('LblOk'),
      accept: () => {
        //Actual logic to perform a confirmation
      }
    });
  }

  public showErrorWithCross(error: string) {
    this._confirmationService.confirm({
      message: error,
      rejectVisible: false,
      icon: 'pi pi-times-circle',
      header: 'Error',
      acceptLabel: this._translateService.instant('LblOk'),
      accept: () => {
        //Actual logic to perform a confirmation
      }
    });
  }

  getAddressFields(address: any) {
    const components = address.address_components || [];
    const obj = {
      Address: '',
      Address1: '',
      Address2: '',
      Town: '',
      Country: '',
      County: '',
      Postcode: '',
    };
    let address1 = '';
    let address2 = '';
    let suburb = '';
    obj.Address = address.formatted_address;
    const countries: any[] = [];
    obj.Address1 = address.name;
    components.forEach((component: any) => {
      const types = component.types;
      types.forEach((type: any) => {
        if (type === 'street_number') {
          address1 = component.long_name;
        }
        if (type === 'route') {
          address1 = (address1 !== '') ? (address1 + ' ' + component.long_name) : component.long_name;
        }
        if (type === 'sublocality') {
          address2 = (address2 !== '') ? (address2 + ' ' + component.long_name) : component.long_name;
        }
        if (type === 'postal_town') {
          obj.Town = component.long_name;
        }
        if (type === 'locality') {
          suburb = component.long_name;
        }
        if (type === 'country') {
          obj.Country = component.long_name;
        }
        if (type === 'administrative_area_level_1') {
          obj.County = component.long_name;
        }
        if (type === 'postal_code') {
          obj.Postcode = component.long_name;
        }
      });
    });
    // obj.Address1 = (address1 === '') ? obj.Address1 : address2;
    obj.Town = (obj.Town === '') ? suburb : obj.Town;
    obj.Address2 = (countries.indexOf(obj.Country) !== -1) ? address2 : '';
    return obj;
  }
}
